export default "__VITE_ASSET__Cnm2IlV1__"